import React, { useEffect, useState } from 'react';
import { X, Heart, Gift } from 'lucide-react';
import { Button } from './ui/button';

export const WelcomeModal = ({ isOpen, onClose, userName }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (isOpen) {
            // Pequeño delay para la animación
            setTimeout(() => setIsVisible(true), 100);
        } else {
            setIsVisible(false);
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const handleClose = () => {
        setIsVisible(false);
        setTimeout(() => onClose(), 300);
    };

    return (
        <div
            className={`fixed inset-0 z-[200] flex items-center justify-center p-4 transition-all duration-300 ${isVisible ? 'bg-black/70 backdrop-blur-sm' : 'bg-black/0'
                }`}
            onClick={handleClose}
        >
            <div
                className={`relative w-full max-w-md bg-gradient-to-br from-primary/10 via-card to-card rounded-[32px] shadow-2xl overflow-hidden border-2 border-primary/30 transition-all duration-500 ${isVisible ? 'scale-100 opacity-100 translate-y-0' : 'scale-90 opacity-0 translate-y-8'
                    }`}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Efectos de fondo */}
                <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
                    <div className="absolute -top-20 -right-20 w-40 h-40 bg-primary/20 rounded-full blur-3xl animate-pulse"></div>
                    <div className="absolute -bottom-20 -left-20 w-40 h-40 bg-primary/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
                </div>

                {/* Botón cerrar */}
                <button
                    onClick={handleClose}
                    className="absolute top-4 right-4 z-10 p-2 hover:bg-secondary/80 rounded-full transition-all duration-200 hover:scale-110"
                >
                    <X className="w-5 h-5" />
                </button>

                {/* Contenido */}
                <div className="relative p-8 space-y-6">
                    {/* Header con icono */}
                    <div className="flex flex-col items-center text-center space-y-4">
                        <div className="relative">
                            <div className="w-24 h-24 flex items-center justify-center shadow-xl animate-bounce">
                                <img
                                    src="/logo.png"
                                    alt="Logo"
                                    className="w-full h-full object-contain rounded-2xl"
                                />
                            </div>
                            <div className="absolute -top-1 -right-1 w-6 h-6 bg-yellow-400 rounded-full animate-ping"></div>
                        </div>

                        <div>
                            <h2 className="text-3xl font-black bg-gradient-to-r from-primary to-primary/60 bg-clip-text text-transparent mb-2">
                                ¡Bienvenido a Tetris Bíblico! 👋
                            </h2>
                            <p className="text-lg font-bold text-foreground">
                                Hola {userName || 'amigo'}
                            </p>
                        </div>
                    </div>

                    {/* Mensaje principal */}
                    <div className="space-y-4 text-sm leading-relaxed">
                        <p className="text-center font-medium">
                            ¡Gracias por unirte a Tetris Bíblico!
                        </p>

                        <div className="bg-gradient-to-r from-primary/20 to-transparent p-4 rounded-2xl border border-primary/20">
                            <div className="flex items-center gap-2 mb-2">
                                <Gift className="w-5 h-5 text-primary" />
                                <p className="font-black text-primary uppercase tracking-wide">
                                    100% GRATIS y SIN PUBLICIDAD
                                </p>
                            </div>
                            <p className="text-xs text-muted-foreground">
                                Disfruta jugando este fabuloso juego mientras lees la Biblia.
                            </p>
                        </div>

                        <p className="text-xs text-muted-foreground text-center">
                            Este es un proyecto hecho con <Heart className="w-4 h-4 inline text-red-500 fill-red-500" /> para ti.
                        </p>

                        <div className="bg-secondary/50 p-4 rounded-2xl space-y-2">
                            <p className="text-xs font-medium">
                                Este servicio es completamente gratuito y sin publicidad. Nos sostenemos solo por medio de ofrendas y donativos voluntarios.
                            </p>

                            <div className="space-y-1 text-xs text-muted-foreground">
                                <p className="font-bold text-foreground">🙏 Cada donativo nos ayuda a:</p>
                                <ul className="space-y-1 pl-4">
                                    <li>✓ Mantener los servidores activos</li>
                                    <li>✓ Crear nuevos niveles y características</li>
                                    <li>✓ Mejorar la experiencia de juego</li>
                                    <li>✓ Producir más contenido educativo bíblico</li>
                                </ul>
                            </div>

                            <p className="text-xs font-bold text-primary text-center pt-2">
                                Puedes donar en la sección "Donar" dentro de la app.
                            </p>
                        </div>

                        <p className="text-center font-bold text-foreground pt-2">
                            ¡Que disfrutes jugando y aprendiendo! 📖🎮
                        </p>
                    </div>

                    {/* Botón de acción */}
                    <div className="pt-4">
                        <Button
                            onClick={handleClose}
                            className="w-full h-14 text-lg font-black rounded-2xl bg-gradient-to-r from-primary to-primary/80 hover:from-primary/90 hover:to-primary/70 shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-105"
                        >
                            ¡Empezar a Jugar! 🎮
                        </Button>
                    </div>

                    {/* Nota adicional */}
                    <p className="text-[10px] text-center text-muted-foreground italic">
                        Este mensaje también está disponible en tu panel de notificaciones
                    </p>
                </div>
            </div>
        </div>
    );
};
